import { ConfigName } from "./ConfigName";

export class Config {
    configId?: number;
    name?: ConfigName;
    value?: string;

}
